import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import {
  mapToCityAndZipCodeOptions,
  mapToCityOptions,
  mapToCountryOptions,
} from 'modules/utils/mappers/locationCodesMappers';

export const selectCountries = (state: RootState) =>
  state.locationCodes.country?.data;

export const selectCountriesOptions = createSelector(
  selectCountries,
  (countries) => mapToCountryOptions(countries),
);

export const selectCities = (state: RootState) =>
  state.locationCodes.city?.data;

export const selectCitiesOptions = createSelector(selectCities, (cities) =>
  mapToCityOptions(cities),
);
export const selectCitiesAndZipCodesOptions = createSelector(
  selectCities,
  (cities) => mapToCityAndZipCodeOptions(cities),
);

export const selectNationalities = (state: RootState) =>
  state.locationCodes.country?.data;

export const selectNationalitiesOptions = createSelector(
  selectNationalities,
  (nationalities) => mapToCountryOptions(nationalities),
);
